import { FC } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {
  TextField,
  InputAdornment,
  useTheme,
  SxProps,
  Theme,
} from '@mui/material';

export interface SearchInputProps {
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  width?: string | number;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

export const SearchInput: FC<SearchInputProps> = ({
  placeholder,
  value,
  onChange,
  fullWidth = false,
  width,
  sx,
  'data-testid': testId,
}) => {
  const theme = useTheme();

  return (
    <TextField
      placeholder={placeholder}
      value={value}
      variant='outlined'
      size='small'
      fullWidth={fullWidth}
      onChange={onChange}
      sx={{
        width: width,
        maxWidth: '100%',
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
        ...sx,
      }}
      slotProps={{
        input: {
          style: {
            height: '40px',
          },
          startAdornment: (
            <InputAdornment position='start' sx={{ mr: -1 }}>
              <SearchIcon fontSize='medium' color='disabled' />
            </InputAdornment>
          ),
        },
        htmlInput: {
          'data-testid': testId,
        },
      }}
    />
  );
};
